export const UPLOAD_TYPES_ID = {
  FILE: 0,
  IMAGE: 1,
  BOTH: 2,
};
